/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SetEnabledRequestBody = {
  /**
   * Whether Speakeasy may sign with the issuer.
   */
  enabled: boolean;
};

/** @internal */
export type SetEnabledRequestBody$Outbound = {
  enabled: boolean;
};

/** @internal */
export const SetEnabledRequestBody$outboundSchema: z.ZodMiniType<
  SetEnabledRequestBody$Outbound,
  SetEnabledRequestBody
> = z.object({
  enabled: z.boolean(),
});

export function setEnabledRequestBodyToJSON(
  setEnabledRequestBody: SetEnabledRequestBody,
): string {
  return JSON.stringify(
    SetEnabledRequestBody$outboundSchema.parse(setEnabledRequestBody),
  );
}
